import type { UseWidget } from '@swf/core/hooks/useWidget';
import { useWidget } from '@swf/core/hooks/useWidget';
import type { WidgetModelConfig } from '@swf/core/store';

import type { SportsMyBetsWidgetConfig } from '../config';

import { defaultState } from './defaultState';
import { effects } from './effects';
import { reducers } from './reducers';
import { selectors } from './selectors';
import type { SportsMyBetsState } from './types';

export interface SportsMyBetsWidgetModel
  extends WidgetModelConfig<SportsMyBetsWidgetConfig, SportsMyBetsState> {
  effects: typeof effects;
  selectors: typeof selectors;
  reducers: typeof reducers & {
    'location/update': typeof reducers.betsChanged;
  };
}

export const sportsMyBetsWidgetModel: SportsMyBetsWidgetModel = {
  state: defaultState,
  reducers: {
    ...reducers,
    'location/update': reducers.betsChanged
  },
  effects,
  selectors
};

export const useSportsMyBetsWidget: UseWidget<SportsMyBetsWidgetConfig, SportsMyBetsWidgetModel> =
  useWidget;
